import React from 'react';
export function AcademiaTotalSection() {
  return <section className="relative z-10 py-6 md:py-8 px-4 cosmic-bg" data-id="element-18">
      <div className="max-w-3xl mx-auto" data-id="element-19">
        {/* Header Badge */}
        <div className="text-center mb-4" data-id="element-20">
          <div className="inline-flex items-center gap-2 bg-purple-500/20 border border-purple-500/50 rounded-full px-4 py-2 mb-3" data-id="element-21">
            <span className="text-lg" data-id="element-22">🟣</span>
            <span className="text-purple-300 font-bold text-xs uppercase tracking-wider" data-id="element-23">
              Para Astrólogas que quieren enseñar
            </span>
          </div>

          {/* Title */}
          <h2 className="text-2xl md:text-3xl font-black text-white mb-2" data-id="element-24">
            PLAN ACADEMIA TOTAL
          </h2>

          {/* Subtitle */}
          <p className="text-sm md:text-base text-white/80 max-w-2xl mx-auto" data-id="element-25">
            Conviértete en referente enseñando tu propio curso de Tarot
          </p>
        </div>

        {/* Features Card */}
        <div className="bg-gradient-to-br from-purple-900/30 to-purple-950/30 border border-purple-500/40 rounded-xl p-4 md:p-5 mb-4" data-id="element-26">
          <div className="space-y-3" data-id="element-27">
            {/* Feature 1 */}
            <div className="flex items-start gap-2.5" data-id="element-28">
              <span className="text-2xl flex-shrink-0" data-id="element-29">📚</span>
              <div data-id="element-30">
                <h3 className="text-white font-black text-base md:text-lg mb-0.5" data-id="element-31">
                  Tarot Master Curriculum
                </h3>
                <p className="text-white/70 text-xs md:text-sm" data-id="element-32">
                  200+ páginas con teoría completa de arcanos
                </p>
              </div>
            </div>

            {/* Feature 2 */}
            <div className="flex items-start gap-2.5" data-id="element-33">
              <span className="text-2xl flex-shrink-0" data-id="element-34">🏆</span>
              <div data-id="element-35">
                <h3 className="text-white font-black text-base md:text-lg mb-0.5" data-id="element-36">
                  Licencia de Re-uso
                </h3>
                <p className="text-white/70 text-xs md:text-sm" data-id="element-37">
                  Editable para tu logo. Véndelo a tus alumnos
                </p>
              </div>
            </div>

            {/* Feature 3 */}
            <div className="flex items-start gap-2.5" data-id="element-38">
              <span className="text-2xl flex-shrink-0" data-id="element-39">📈</span>
              <div data-id="element-40">
                <h3 className="text-white font-black text-base md:text-lg mb-0.5" data-id="element-41">
                  Estructura de Clases
                </h3>
                <p className="text-white/70 text-xs md:text-sm" data-id="element-42">
                  Paso a paso para resultados reales
                </p>
              </div>
            </div>
          </div>

          {/* Value Proposition */}
          <div className="bg-black/40 border border-purple-500/30 rounded-lg p-3 mt-4" data-id="element-43">
            <p className="text-white text-xs md:text-sm text-center" data-id="element-44">
              <strong className="text-purple-400 font-black" data-id="element-45">
                Ahorra 6 meses:
              </strong>{' '}
              Todo listo para lanzar tu curso de Tarot
            </p>
          </div>
        </div>

        {/* CTA */}
        <div className="text-center" data-id="element-46">
          <a href="#comprar" className="inline-flex items-center gap-2 text-purple-400 hover:text-purple-300 font-bold text-xs md:text-sm transition-colors" data-id="element-47">
            Ver Plan Academia Total arriba ↑
          </a>
        </div>
      </div>
    </section>;
}